import React from "react";
import FAQAccordion from '../FAQAccordion';

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    /**
     * Your ajax will goes here to get data then call setState
     */
  }

 render() {
  return (
    <React.Fragment>
      <section id="info-lace-hiking-boots" className="about-us pt-trip gray-light-bg">
        <div className="container">
          <div className="row justify-content-center">
            <div>
              <div className="section-heading mb-5 mx-2">
                {this.props.showTitle && this.props.showTitle === true && (
                  <span className="badge badge-primary badge-pill">
                    Hiking Boot Lacing
                  </span>
                )}
                <h1 className="text-center">
                  How to Lace Hiking Boots (Complete Beginner Guide)
                  <br />
                </h1>

                <p>
                  Lacing your hiking boots correctly can make a bigger difference than most people think.
                  The way you lace your boots affects comfort, stability, and even how tired your feet
                  feel at the end of a hike.
                </p>

                <p>
                  Poor lacing can lead to blisters, foot pain, and lack of support on uneven terrain.
                  The good news is that you do not need new boots to fix these problems. Small
                  adjustments to your lacing technique can completely change how your boots feel.
                </p>

                <p>
                  In this guide, you will learn how to lace hiking boots properly, along with different
                  techniques you can use depending on your foot shape and the type of hike.
                </p>

                <p>
                  If you are planning your next hike, check out our guide on{" "}
                  <a className="in-text-link" href="/how-to-use-hiking-poles-correctly">
                    how to use hiking poles correctly
                  </a>{" "}
                  to improve balance and reduce strain on the trail.
                </p>
                <FAQAccordion
                  title="How to Lace Hiking Boots FAQs"
                  items={[
                    { q: 'What is the best lacing technique for hiking boots?', a: "The surgeon's knot (also called a locking knot) is the most useful technique. Lock the laces at the ankle to separate the toe box tension from the ankle tension, giving you a customized fit in each zone." },
                    { q: 'How should hiking boots fit when properly laced?', a: "Your toes should have about a thumb's width of space at the front. The heel should not slip when walking uphill. The midfoot should feel snug but not tight. No pressure points or pinching on the sides." },
                    { q: 'Why do my feet hurt when hiking even with good boots?', a: 'Often due to improper lacing. If your toes jam on descents, lace too tight at the toe box. If your heel slips, use a heel-lock lacing technique. If you have hot spots, reduce pressure at that point by skipping an eyelet.' },
                    { q: 'How do you lace hiking boots to prevent blisters?', a: "Use a surgeon's knot at the ankle to lock the heel in place and reduce movement. Moisture-wicking socks and properly fitted boots matter equally. Replace worn laces that create uneven pressure." },
                    { q: 'What is the heel-lock lacing technique?', a: 'Thread the lace through the top hook and loop it back through the adjacent hook before tying. This creates a figure-eight that locks the heel in place and prevents slippage on steep descents.' },
                    { q: 'How tight should hiking boots be laced?', a: "Snug but not cutting off circulation. You should be able to slide a finger under the laces at the top of the foot. Your foot should feel held without numbness or tingling. Loosen slightly on long flat sections." },
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}
}
export default About;